<template>
  <div class="app-main-inner-row operations">
    <div class="triggers">
      <div>
        <el-button v-if="type==='add'" no="1" type="success" @click="eventTrigger('accountingDocumentSaveAndAdd')">{{ $t('CargoMsg.Cargo_SaveAndAdd') }}</el-button>
        <el-button no="2" type="success" @click="eventTrigger('accountingDocumentSave')">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button v-if="type!=='copy'" no="3" type="primary" :disabled="!hasId || audited" @click="eventTrigger('accountingDocumentAccept')">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
        <el-button v-if="type!=='copy'" no="4" type="danger" :disabled="!hasId || !audited" @click="eventTrigger('accountingDocumentReject')">{{ $t('CargoMsg.Cargo_ReverseReview') }}</el-button>
        <el-button v-if="type!=='copy'" no="5" type="danger" :disabled="!hasId" @click="eventTrigger('accountingDocumentDeleted')">{{ $t('CargoMsg.Cargo_OrderDelete') }}</el-button>
        <el-button v-if="type!=='copy'" no="6" type="primary" :disabled="!hasId" @click="eventTrigger('accountingDocumentPrint')">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-button no="7" type="primary" :disabled="!hasSelected" @click="eventTrigger('accountingDocumentGridAddItem')">{{ $t('CargoMsg.Cargo_InsertJournalEntry') }}</el-button>
        <el-button no="8" type="danger" :disabled="!hasSelected" @click="eventTrigger('accountingDocumentGridDeleteItem')">{{ $t('CargoMsg.Cargo_DeleteAccountingEntry') }}</el-button>
        <el-button no="9" type="primary" :disabled="!hasSelected" @click="eventTrigger('accountingDocumentGridExchange')">{{ $t('CargoMsg.Cargo_LoanSwap') }}</el-button>
        <el-button no="10" type="primary" :disabled="!hasSelected" @click="eventTrigger('accountingDocumentGridCalculateBalance')">{{ $t('CargoMsg.Cargo_CalculateBalance') }}</el-button>
        <el-button v-if="type!=='add'" no="11" type="warning" @click="eventTrigger('accountingDocumentCancel')">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
export default {
  name: 'AccountingDocumentBtnGroup',
  props: {
    type: {
      type: String,
      default: () => 'add'
    }
  },
  data() {
    return {
      hasSelected: false,
      voucher: null
    }
  },
  computed: {
    hasId() {
      return this.voucher ? this.voucher.uuid : false
    },
    audited() {
      return this.voucher && this.voucher.verifier !== 0
    }
  },
  created() {
    EventBus.$on('accountingDocumentGridItemSelected', (hasSelected) => {
      this.hasSelected = hasSelected
    })
    EventBus.$on('voucherChanged', (voucher) => {
      this.voucher = voucher
    })
  },
  beforeDestroy() {
    EventBus.$off()
  },
  methods: {
    eventTrigger(event) {
      EventBus.$emit(event)
    }
  }
}
</script>

<style scoped>

</style>
